import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CountryDto {
  countryCode?: string;
  countryNumeric?: string;
  countryName: string;
  continent?: string;
  isEU: boolean;
  isEEA: boolean;
  isVatMossApplicable: boolean;
  isReverseChargeApplicable: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  /**
   * Alte Methode für Kompatibilität - returnt nur Ländernamen (alphabetisch)
   */
  getCountries(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/countries/names`);
  }

  /**
   * Neue Methode - returnt alle Länder mit allen Details (alphabetisch)
   * Includes: CountryCode, CountryNumeric, CountryName, Continent, IsEU, IsEEA, IsVatMossApplicable, IsReverseChargeApplicable
   */
  getCountriesWithDetails(): Observable<CountryDto[]> {
    return this.http.get<CountryDto[]>(`${this.apiUrl}/countries`);
  }

  /**
   * Einzelnes Land nach Namen suchen
   */
  getCountryByName(countryName: string): Observable<CountryDto> {
    return this.http.get<CountryDto>(`${this.apiUrl}/countries/${encodeURIComponent(countryName)}`);
  }

  /**
   * Einzelnes Land nach ISO Code suchen (z.B. 'DE')
   */
  getCountryByCode(countryCode: string): Observable<CountryDto> {
    return this.http.get<CountryDto>(`${this.apiUrl}/countries/code/${encodeURIComponent(countryCode)}`);
  }
}
